import React from 'react';
import intl from 'react-intl-universal';

import { Box, DotLoader } from '..';

import styles from './styles.scss';

function renderText(text) {

  // If there isn't any text to render, don't render it...
  if (!text) {
    return null;
  }

  return (
    <div className={ styles.text }>
      { text }
    </div>
  );
}

const Loader = ({ text }) => (
  <Box className="selection-box">
    <DotLoader />
    { renderText(text) }
  </Box>
);
Loader.defaultProps = {
  text: intl.get('Your images will be ready in just a few seconds.')
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.jsx